import {
  basketsGQLQuery,
  billingDetailsGQLQuery,
  invoicesGQLQuery,
  purchaseGQLMutation,
  updateBillingDetailsGQLMutation,
  vatTypesGQLQuery,
} from '../../graphql/index.js'
import {
  Basket,
  BillingDetails,
  Invoice,
  MutationPurchaseArgs,
  MutationUpdateBillingDetailsArgs,
  QueryBasketsArgs,
  Subscription,
  VatTypeInfo,
} from '../../types/index.js'
import { GraphqlClient } from '../graphql.client.js'

export class BillingClient {
  private client: GraphqlClient

  constructor(client: GraphqlClient) {
    this.client = client
  }

  async details(accessToken?: string): Promise<BillingDetails> {
    type QueryResult = { billingDetails: BillingDetails }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: billingDetailsGQLQuery(),
      customToken: accessToken,
    })
    return result.billingDetails
  }

  async invoices(accessToken?: string): Promise<Invoice[]> {
    type QueryResult = { invoices: Invoice[] }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: invoicesGQLQuery(),
      customToken: accessToken,
    })
    return result.invoices
  }

  async vatTypes(accessToken?: string): Promise<VatTypeInfo[]> {
    type QueryResult = { vatTypes: VatTypeInfo[] }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: vatTypesGQLQuery(),
      customToken: accessToken,
    })
    return result.vatTypes
  }

  async purchase(
    variables: MutationPurchaseArgs,
    accessToken?: string,
  ): Promise<Subscription> {
    type QueryResult = { purchase: Subscription }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: purchaseGQLMutation(),
      variables,
      customToken: accessToken,
    })
    return result.purchase
  }

  async updateDetails(
    variables: MutationUpdateBillingDetailsArgs,
    accessToken?: string,
  ): Promise<BillingDetails> {
    type QueryResult = { updateBillingDetails: BillingDetails }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: updateBillingDetailsGQLMutation(),
      variables,
      customToken: accessToken,
    })
    return result.updateBillingDetails
  }

  async baskets(
    variables: QueryBasketsArgs,
    accessToken?: string,
  ): Promise<Basket[]> {
    type QueryResult = { baskets: Basket[] }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: basketsGQLQuery(),
      variables,
      customToken: accessToken,
    })
    return result.baskets
  }
}
